import React from "react";
import styles from "./loader.module.css";

const Loaderflip = () => {
  return (
    <div className={styles.lodercontatin}>
      <div className="text-center">
        <div className={"spinner-border " + styles.loadingFlip} role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <p>Updating....</p>
      </div>
    </div>
  );
};

export default Loaderflip;
